export var PopoverPosition = {
  TopLeft: 'top left',
  Top: 'top',
  TopRight: 'top right',
  RightTop: 'right top',
  Right: 'right',
  RightBottom: 'right bottom',
  BottomRight: 'bottom right',
  Bottom: 'bottom',
  BottomLeft: 'bottom left',
  LeftBottom: 'left bottom',
  Left: 'left',
  LeftTop: 'left top'
};